import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { environment } from '@environments/environment';
import { AppHttpHeadersService } from './headers/app-http-headers.service';
import { HttpHeadersService } from './headers/http-headers.service';
import { SocketEvent } from '@model/socket-event';
import { SocketEventStorage } from '@storage/socket-event.storage';
import { LocalSettingsKey } from '@shared/types/local-settings';
import { BehaviorSubject } from 'rxjs';
import { RefreshTokenService } from '@service/rest/refresh-token/refresh-token.service';

@Injectable({
  providedIn: 'root',
})
export class EventStreamService {
  eventSource: EventSourcePolyfill;
  isBackToOnlineToBeTriggered: boolean = false;
  usedToken: string;
  private refreshSocket = new BehaviorSubject<boolean>(false);

  constructor(
    private appHttpHeadersService: AppHttpHeadersService,
    private httpHeadersService: HttpHeadersService,
    private socketEventStorage: SocketEventStorage,
    private refreshTokenService: RefreshTokenService
  ) { }

  getRefreshSocket(): Observable<boolean> {
    return this.refreshSocket;
  }

  getEventSource(): void {
    if (this.eventSource) {
      this.eventSource.close();
    }
    this.usedToken = this.appHttpHeadersService.getUserToken();
    this.eventSource = new EventSourcePolyfill(environment.socket_url + '?ngsw-bypass=true', {
      headers: {
        Authorization: 'Bearer ' + this.usedToken,
        'App-Version': this.httpHeadersService.generateAppVersion(),
        'Device-Language': this.httpHeadersService.generateDeviceLanguage(),
        'Device-Name': this.httpHeadersService.generateDeviceName(),
        'Device-OS': this.httpHeadersService.generateDeviceOs(),
        'Device-ID': this.httpHeadersService.generateDeviceId(),
      },
      heartbeatTimeout: 12000,
    });
  }

  getSocketEvents(): Observable<any> {
    return new Observable(observer => {
      this.getEventSource();

      this.eventSource.addEventListener('open', event => {
        console.log('open : ', event);
        if (this.isBackToOnlineToBeTriggered === true) {
          this.triggerBackToOnlineEvent();
          this.isBackToOnlineToBeTriggered = false;
        }
      });

      this.eventSource.addEventListener('message', message => {
        console.log('message : ', message);
        if (message.data === 'NOK') {
          // Tokenin geçersiz olduğu durumlarda NOK dönerse token yenilenip yeni socket bağlantısı kuruluyor.
          this.refreshSocketSession();
        } else {
          observer.next(message.data);
        }
      });

      this.eventSource.addEventListener('error', error => {
        console.log('error : ', error);
        this.isBackToOnlineToBeTriggered = true;
        this.closeEventSource();
      });
    });
  }

  closeEventSource(): void {
    if (this.appHttpHeadersService.getUserToken() === undefined) {
      this.closeSocket();
    }
  }

  refreshSocketSession(): void {
    this.closeSocket();
    console.log('Socket Kapandı');
    if (this.appHttpHeadersService.getUserToken()) {
      this.refreshTokenService.refreshToken(true).subscribe(() => {
        this.refreshSocket.next(true);
      });
    }
  }

  triggerBackToOnlineEvent(): void {
    setTimeout(() => {
      const parsedUsername = this.getUsername();
      if (parsedUsername) {
        const socketEvent = new SocketEvent(parsedUsername, 'ONLINE');
        this.socketEventStorage.refreshSocketMailEventInfo([{ ...socketEvent, itemType: 'MESSAGE', eventDescription: 'MESSAGE-ONLINE' }]);
        this.socketEventStorage.refreshSocketMailAndConversationEventInfo([
          { ...socketEvent, itemType: 'MESSAGE', eventDescription: 'MESSAGE-ONLINE' },
        ]);
        this.socketEventStorage.refreshSocketContactEventInfo([{ ...socketEvent, itemType: 'CONTACT', eventDescription: 'CONTACT-ONLINE' }]);
        this.socketEventStorage.refreshSocketCalendarEventInfo([{ ...socketEvent, itemType: 'CALENDAR', eventDescription: 'CALENDAR-ONLINE' }]);
      }
    }, 3000);
  }

  getUsername(): string {
    const user = localStorage.getItem(LocalSettingsKey.USER);
    let parsedUsername;
    if (user !== null && user !== undefined) {
      parsedUsername = JSON.parse(localStorage.getItem(LocalSettingsKey.USER)).username;
    }
    return parsedUsername;
  }

  private closeSocket(): void {
    this.isBackToOnlineToBeTriggered = false;
    this.eventSource.close();
  }
}
